import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { withTranslation } from 'react-i18next';
import { SCHOOL_TERM_TYPE } from '../../../shared/utils/constants';

const SchoolDaySelector = ({ input, t, ...rest }) => {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        style={{ display: 'flex', width: '50%' }}
      >
        <RadioButton
          iconStyle={{ fill: '#6A2B8B' }}
          labelStyle={{ color: '#30313F' }}
          value
          label={SCHOOL_TERM_TYPE.LEARNING}
        />
        <RadioButton
          iconStyle={{ fill: '#6A2B8B' }}
          labelStyle={{ color: '#30313F' }}
          value={false}
          label={SCHOOL_TERM_TYPE.UN_LEARNING}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
};

SchoolDaySelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(SchoolDaySelector);
